/** Centralized data-testids for the GigLine app. */
export const TEST_IDS = {
  // Auth
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-btn',
  loginError: 'login-error',
  // Nav
  navDashboard: 'nav-dashboard',
  navNewEngagement: 'nav-new-engagement',
  navReports: 'nav-reports',
  navSettings: 'nav-settings',
  logoutBtn: 'logout-btn',
  // Dashboard
  dashboardActiveTab: 'dashboard-active-tab',
  dashboardCompletedTab: 'dashboard-completed-tab',
  newEngagementBtn: 'new-engagement-btn',
  engagementCard: (id) => `engagement-card-${id}`,
  // New engagement
  engTypeWalkthrough: 'eng-type-walkthrough',
  engTypeGapCheck: 'eng-type-gap-check',
  engTypeCombined: 'eng-type-combined',
  engBusinessName: 'eng-business-name',
  engContactName: 'eng-contact-name',
  engContactEmail: 'eng-contact-email',
  engContactPhone: 'eng-contact-phone',
  engSiteAddress: 'eng-site-address',
  engIndustry: 'eng-industry',
  engVisitDate: 'eng-visit-date',
  engNotes: 'eng-notes',
  engSubmit: 'eng-create-submit',
  // Engagement detail
  tabSetup: 'tab-setup',
  tabFindings: 'tab-findings',
  tabChecklist: 'tab-checklist',
  tabMedia: 'tab-media',
  tabReport: 'tab-report',
  addFindingBtn: 'add-finding-btn',
  findingCard: (id) => `finding-card-${id}`,
  finPriority: 'fin-priority',
  finViolationType: 'fin-violation-type',
  finCfrCitation: 'fin-cfr-citation',
  finStandardName: 'fin-standard-name',
  finPenalty: 'fin-penalty',
  finDescription: 'fin-description',
  finCorrective: 'fin-corrective',
  finVideoUrl: 'fin-video-url',
  finPhotoUpload: 'fin-photo-upload',
  finSubmit: 'fin-submit-btn',
  finCancel: 'fin-cancel-btn',
  finDelete: (id) => `fin-delete-${id}`,
  cfrLookupBtn: 'cfr-lookup-btn',
  cfrLookupInput: 'cfr-lookup-input',
  cfrLookupSubmit: 'cfr-lookup-submit',
  cfrLookupApply: 'cfr-lookup-apply',
  // Gap check
  gapItemRow: (id) => `gap-item-${id}`,
  gapStatusPresent: (id) => `gap-status-present-${id}`,
  gapStatusOutdated: (id) => `gap-status-outdated-${id}`,
  gapStatusMissing: (id) => `gap-status-missing-${id}`,
  gapNotes: (id) => `gap-notes-${id}`,
  // Report
  generateReportBtn: 'generate-report-btn',
  copyLinkBtn: 'copy-link-btn',
  emailHandoffBtn: 'email-handoff-btn',
  downloadPdfBtn: 'download-pdf-btn',
  deactivateLinkBtn: 'deactivate-link-btn',
  markDeliveredBtn: 'mark-delivered-btn',
  // Settings
  settingsDisclaimer: 'settings-disclaimer',
  settingsFooter: 'settings-footer',
  settingsSave: 'settings-save-btn',
  // Offline banner / sync
  offlineBanner: 'offline-banner',
  syncBadge: 'sync-badge',
};
